import { PmeTarifacaoPage } from '@/features/proposal-analyses/pme';
import {
  requireInsurerUnderwritingAccess,
  requirePermissions,
} from '@/shared/utils';
import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/_app/proposal-analyses/$proposalId/pricing/'
)({
  component: RouteComponent,
  beforeLoad: async () => {
    const [hasPermission, hasUnderwritingAccess] = await Promise.all([
      requirePermissions(['policies.proposals.read']),
      requireInsurerUnderwritingAccess(),
    ]);
    if (!hasPermission || !hasUnderwritingAccess) {
      throw redirect({ to: '/dashboard' });
    }
  },
});

function RouteComponent() {
  const { proposalId } = Route.useParams();
  return <PmeTarifacaoPage policyId={proposalId} context='proposal' />;
}
